import { useNavigate } from "react-router-dom";
import Icon from "../../UI/Icon/Icon";
import PrimaryButton from "../../UI/PrimaryButton/PrimaryButton";
import Thanks from "../../../assets/svg/thanks.svg";
import classes from "./ThankYou.module.scss";

const ThankYou = () => {
  const navigate = useNavigate();

  const goHome = () => {
    navigate("/home");
  };

  return (
    <div className={classes.ThankYouBox}>
      <h1>Thank you!</h1>
      <p>
        Your ordered has been confirmed <Icon name="confirm" />
      </p>
      {/* <Icon name="thanks" /> */}
      <img src={Thanks} alt="" />
      <PrimaryButton text="Back to home" onClicked={goHome} />
    </div>
  );
};

export default ThankYou;
